import type { IconNode } from '../types';

/**
 * @name kazakh-tenge
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgOHYxMiIgLz4KICA8cGF0aCBkPSJNNiA0aDEyIiAvPgogIDxwYXRoIGQ9Ik02IDhoMTIiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/kazakh-tenge
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const KazakhTenge: IconNode = [
  ['path', { d: 'M12 8v12' }],
  ['path', { d: 'M6 4h12' }],
  ['path', { d: 'M6 8h12' }],
];

export default KazakhTenge;
